'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../css/ConfigBox.css');

var _ExtendedButton = require('./ExtendedButton');

var _ExtendedButton2 = _interopRequireDefault(_ExtendedButton);

var _Checkbox = require('./Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// in der ConfigBox wird eine Liste von Checkboxen angezeigt
// über die Checkboxen können Konfigurationen für die Parent sEite gemacht werden

/*
Pflichtproperties:
AppURL={Vas.ApplicationUrl} 
LabelPanelsShow={Vas.Resources.Labels["PanelsShow"]}
optional:

*/

var ConfigBox = function (_Component) {
    _inherits(ConfigBox, _Component);

    function ConfigBox(props) {
        _classCallCheck(this, ConfigBox);

        var _this = _possibleConstructorReturn(this, (ConfigBox.__proto__ || Object.getPrototypeOf(ConfigBox)).call(this, props));

        _this.state = {};
        _this.state.Open = false;
        _this.messen = _this.messen.bind(_this);
        _this.state.drag = false;
        return _this;
    }

    _createClass(ConfigBox, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.dragElement(document.getElementById("MessageBox"));
            if (this.props.modal === true) {
                this.toggleModal();
            }

            window.addEventListener("resize", this.messen);

            //Festlegen, ob die Checkboxen gecheckt sind
            var elms = document.querySelectorAll(".checkbox");
            for (var i = 0; i < this.props.Panels.length; i++) {
                for (var j = 0; j < elms.length; j++) {
                    if (this.props.Panels[i][0] === elms[j].id) {
                        elms[j].checked = true;
                    }
                }
            }

            this.messen();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.drag === false) {
                this.messen();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.modal === true) {
                this.toggleModal();
            }
        }
    }, {
        key: 'messen',
        value: function messen() {
            if (document.getElementById("MessageBox")) {
                var top = null;
                var left = null;

                var windowWidth = window.innerWidth / 2;
                var windowHeight = window.innerHeight / 2;

                var width = document.getElementById("MessageBox").offsetWidth / 2;
                var height = document.getElementById("MessageBox").clientHeight / 2;

                if (width > windowWidth) {
                    left = -windowWidth;
                } else {
                    left = -width;
                }

                if (height > windowHeight) {
                    top = -windowHeight;
                } else {
                    top = -height;
                }

                document.getElementById("MessageBox").style.marginLeft = left + "px";
                document.getElementById("MessageBox").style.marginTop = top + "px";
            }
        }
    }, {
        key: 'Close',
        value: function Close() //Schließen
        {
            _reactDom2.default.unmountComponentAtNode(document.getElementById('popupContainer'));
            (0, _jquery2.default)("#Content").css("opacity", "1");
        }
    }, {
        key: 'Accept',
        value: function Accept() {
            //neuen Konfiguration übernehmen
            var elms = document.querySelectorAll(".checkbox");
            var res = [];
            for (var i = 0; i < elms.length; i++) {
                if (elms[i].checked === true) {
                    res.push([elms[i].id, true]);
                }
            }
            this.props.Reference.Refresh(res); //rufe die Methode Refresh() der Parentseite auf
            this.Close();
        }
    }, {
        key: 'toggleModal',
        value: function toggleModal() {
            var modal = document.querySelector(".modal");
            modal.classList.toggle("show-modal");
        }

        //#region drag&drop

    }, {
        key: 'dragElement',
        value: function dragElement(elmnt) {
            //https://www.w3schools.com/howto/tryit.asp?filename=tryhow_js_draggable 08.08.2018
            var pos1 = 0,
                pos2 = 0,
                pos3 = 0,
                pos4 = 0;
            var me = this;
            if (document.getElementById(elmnt.id + "Header")) {
                /* if present, the header is where you move the DIV from:*/
                document.getElementById(elmnt.id + "Header").onmousedown = dragMouseDown;
            } else {
                /* otherwise, move the DIV from anywhere inside the DIV:*/
                elmnt.onmousedown = dragMouseDown;
            }

            function dragMouseDown(e) {
                e = e || window.event;
                e.preventDefault();
                // get the mouse cursor position at startup:
                pos3 = e.clientX;
                pos4 = e.clientY;
                document.onmouseup = closeDragElement;
                // call a function whenever the cursor moves:
                document.onmousemove = elementDrag;
                me.setState({ drag: true });
            }

            function elementDrag(e) {
                e = e || window.event;
                e.preventDefault();
                // calculate the new cursor position:
                pos1 = pos3 - e.clientX; //Differenz -> Anzahl der Pixel 
                pos2 = pos4 - e.clientY;
                pos3 = e.clientX;
                pos4 = e.clientY;

                var left = elmnt.style.marginLeft;
                left = Number(left.replace("px", ''));
                var top = elmnt.style.marginTop;
                top = Number(top.replace("px", ''));

                // set the element's new position:
                elmnt.style.marginLeft = left - pos1 + "px";
                elmnt.style.marginTop = top - pos2 + "px";

                //elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
                //elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
            }

            function closeDragElement() {
                /* stop moving when mouse button is released:*/
                document.onmouseup = null;
                document.onmousemove = null;
            }
        }
        //#endregion

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            //Auflistung aller Checkboxen
            var text = '';
            var i = 0;
            if (this.props.Context) {
                // eslint-disable-next-line array-callback-return
                text = this.props.Context.map(function (c) {
                    i++;
                    if (c !== undefined) {
                        return _react2.default.createElement(
                            'div',
                            {
                                key: i,
                                id: i },
                            _react2.default.createElement(_Checkbox2.default, { Id: c.props.Id }),
                            c.props.Header
                        );
                    }
                });
            }

            var className = '';
            if (this.props.modal === true) {
                className = "modal";
            }

            (0, _jquery2.default)("#Content").css("opacity", "0.4");
            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    'div',
                    {
                        id: "MessageBox",
                        className: "ConfigBox" },
                    _react2.default.createElement(
                        'div',
                        {
                            id: "MessageBoxHeader",
                            className: "ConfigBoxTitle" },
                        this.props.LabelPanelsShow,
                        _react2.default.createElement(_Icon2.default, {
                            AppURL: this.props.AppURL,
                            Name: "Close",
                            Style: { cursor: 'pointer' },
                            Size: 24,
                            Color: "white",
                            Align: "right",
                            OnClick: function OnClick() {
                                _this2.Close();
                            } })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: "ConfigBoxMessageContainer" },
                        text
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_ExtendedButton2.default, {
                            Usable: true,
                            Text: _react2.default.createElement(_Icon2.default, {
                                AppURL: this.props.AppURL,
                                Name: "Done",
                                Size: 24,
                                Color: "white",
                                PaddingLeft: '3px',
                                PaddingTop: '1px' }),
                            Width: 30,
                            Height: 30,
                            style: { marginTop: '2px !important' },
                            Float: 'right',
                            OnClick: function OnClick() {
                                _this2.Accept();
                            } })
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_ExtendedButton2.default, {
                            Usable: true,
                            Text: _react2.default.createElement(_Icon2.default, {
                                AppURL: this.props.AppURL,
                                Name: "Close",
                                Size: 24,
                                Color: "white",
                                PaddingLeft: '3px',
                                PaddingTop: '1px' }),
                            Width: 30,
                            Height: 30,
                            style: { marginTop: '2px !important' },
                            Float: 'right',
                            OnClick: function OnClick() {
                                _this2.Close();
                            } })
                    )
                )
            );
        }
    }]);

    return ConfigBox;
}(_react.Component);

exports.default = ConfigBox;